import { appUrl } from "@/lib/app-links"

/** Full public launch — opt out of coming-soon landing and waitlist-first marketing. */
const LIVE_LAUNCH_MODE = "live"

export function isLaunchMode(): boolean {
  const mode = import.meta.env.VITE_LAUNCH_MODE?.trim()
  return mode !== LIVE_LAUNCH_MODE
}

export function areSignupsEnabled(): boolean {
  return import.meta.env.VITE_SIGNUPS_ENABLED === "true"
}

/**
 * The one real destination for every "get started" CTA on marketing pages —
 * never a mailto link, never an inline form on the page it's clicked from.
 * Points at this site's own /request-access page while in coming-soon mode,
 * or at the app's /sign-up once the site is fully live (which itself
 * redirects back to /request-access if signups are still gated, so this
 * stays correct even if the two flags fall out of sync).
 */
export function primaryCtaHref(): string {
  return isLaunchMode() ? "/request-access" : appUrl("/sign-up")
}

/** Label to pair with `primaryCtaHref()` — reflects what actually happens at that destination. */
export function primaryCtaLabel(): string {
  return areSignupsEnabled() ? "Sign up" : "Request access"
}

/**
 * Secondary CTA: a low-commitment "tell me when it's generally available" signup,
 * distinct from `primaryCtaHref()` (request a place in the current limited run).
 */
export function waitlistHref(): string {
  return "/waitlist"
}

export function waitlistLabel(): string {
  return "Get notified at launch"
}
